import { render, staticRenderFns } from "./LegacyEntryDirection.vue?vue&type=template&id=99ebb190&scoped=true&"
import script from "./LegacyEntryDirection.vue?vue&type=script&lang=js&"
export * from "./LegacyEntryDirection.vue?vue&type=script&lang=js&"
import style0 from "./LegacyEntryDirection.vue?vue&type=style&index=0&id=99ebb190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ebb190",
  null
  
)

export default component.exports